import { render, staticRenderFns } from "./SitePlanOpportunitiesComponent.vue?vue&type=template&id=4287446a&"
import script from "./SitePlanOpportunitiesComponent.vue?vue&type=script&lang=js&"
export * from "./SitePlanOpportunitiesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports